import { HeroId } from "../../../../shared/src/index.ts";
import type { VoiceScript } from "../voice-types.ts";

const script = {
  hero: HeroId.CloakSwagger,
  voices: {
    cloak: {
      description:
        "low male shadow baritone, hushed velvet, protective streetwise gravity, close dark-room texture, soft consonants with a cold edge",
      seed: 10973,
      guidance: 0.76,
      loudness: 0.74,
      fx: { eq: "dark", reverb: 0.18 },
    },
    swagger: {
      description:
        "bright young female alto, radiant stylish dancer confidence, crisp smile in the tone, clean pop vocal presence",
      seed: 10974,
      guidance: 0.78,
      loudness: 0.78,
      fx: { eq: "bright" },
    },
  },
  lines: {
    select: [
      {
        id: "select_1_swagger",
        text: "We are Cloak and Swagger, we are hope and fear.",
        voice: "swagger",
        form: 0,
      },
      {
        id: "select_2_swagger",
        text: "Cloak and Swagger popping in.",
        voice: "swagger",
        form: 0,
      },
      {
        id: "select_3_cloak",
        text: "Tandy and Tyrone here to help.",
        voice: "cloak",
        form: 1,
      },
      {
        id: "select_4_cloak",
        text: "You got both Cloak and Swagger.",
        voice: "cloak",
        form: 1,
      },
    ],
    spawn: [
      {
        id: "spawn_1_swagger",
        text: "Didn't know feeling bad could feel so good…",
        voice: "swagger",
        form: 0,
      },
      {
        id: "spawn_2_swagger",
        text: "Now's your chance to prove yourself, Hood. Don't waste it.",
        voice: "swagger",
        form: 0,
      },
      {
        id: "spawn_3_swagger",
        text: "Get ready… There's a cold snap coming…",
        voice: "swagger",
        form: 0,
      },
      {
        id: "spawn_4_swagger",
        text: "C'mon, Luna! Let's turn up the volume and turn down the heat!",
        voice: "swagger",
        form: 0,
      },
      {
        id: "spawn_5_swagger",
        text: "I don't think I could handle the pressure of the Darkforce.",
        voice: "swagger",
        form: 0,
      },
      {
        id: "spawn_6_swagger",
        text: "It took us a long time to learn that our powers are related.",
        voice: "swagger",
        form: 0,
      },
      {
        id: "spawn_7_swagger",
        text: "We won't run away anymore!",
        voice: "swagger",
        form: 0,
      },
      {
        id: "spawn_8_swagger",
        text: "There's always a spark of light in darkness.",
        voice: "swagger",
        form: 0,
      },
      {
        id: "spawn_9_swagger",
        text: "Without Ty, I wouldn't know the real power of the Lightforce.",
        voice: "swagger",
        form: 0,
      },
      {
        id: "spawn_10_swagger",
        text: "Before we had powers, we had each other. That bond is unbreakable.",
        voice: "swagger",
        form: 0,
      },
      {
        id: "spawn_11_swagger",
        text: "Ty and I create equilibrium. When it gets disturbed…",
        voice: "swagger",
        form: 0,
      },
      {
        id: "spawn_12_swagger",
        text: "Light can heal, and light can harm. Same with me.",
        voice: "swagger",
        form: 0,
      },
      {
        id: "spawn_13_swagger",
        text: "People are always afraid of Ty, but they just don't know him.",
        voice: "swagger",
        form: 0,
      },
      {
        id: "spawn_14_swagger",
        text: "Light doesn't dispel darkness. It helps me see the darkness, and face it.",
        voice: "swagger",
        form: 0,
      },
      {
        id: "spawn_15_cloak",
        text: "Ain't no darkness can swallow me, I can do this!",
        voice: "cloak",
        form: 1,
      },
      {
        id: "spawn_16_cloak",
        text: "Light and dark need each other to exist.",
        voice: "cloak",
        form: 1,
      },
      {
        id: "spawn_17_cloak",
        text: "Rise up, fight back!",
        voice: "cloak",
        form: 1,
      },
      {
        id: "spawn_18_cloak",
        text: "It's not easy, holding the Darkforce in check.",
        voice: "cloak",
        form: 1,
      },
      {
        id: "spawn_19_cloak",
        text: "If I didn't have Tandy, the Darkforce would have taken me a long time ago.",
        voice: "cloak",
        form: 1,
      },
      {
        id: "spawn_20_cloak",
        text: "It's always been me and Tandy against the world.",
        voice: "cloak",
        form: 1,
      },
      {
        id: "spawn_21_cloak",
        text: "I wonder how chronovium plays with the Darkforce…",
        voice: "cloak",
        form: 1,
      },
      {
        id: "spawn_22_cloak",
        text: "Before we put all these worlds back together, I want to see some places I'll never see again.",
        voice: "cloak",
        form: 1,
      },
      {
        id: "spawn_23_cloak",
        text: "Somebody needs to make the Dooms pay for what they've done.",
        voice: "cloak",
        form: 1,
      },
    ],
    respawn: [
      {
        id: "respawn_1_cloak",
        text: "Much to prove!",
        voice: "cloak",
        form: 1,
      },
      {
        id: "respawn_2_cloak",
        text: "Let's get into some good trouble.",
        voice: "cloak",
        form: 1,
      },
      {
        id: "respawn_3_cloak",
        text: "I wasn't sure we'd get this chance again.",
        voice: "cloak",
        form: 1,
      },
      {
        id: "respawn_4_cloak",
        text: "Still here. Don't you put me out.",
        voice: "cloak",
        form: 1,
      },
      {
        id: "respawn_5_swagger",
        text: "Ahh… Just keep goin'",
        voice: "swagger",
        form: 0,
      },
      {
        id: "respawn_6_swagger",
        text: "Swagger's back!",
        voice: "swagger",
        form: 0,
      },
      {
        id: "respawn_7_swagger",
        text: "The light always comes back.",
        voice: "swagger",
        form: 0,
      },
      {
        id: "respawn_8_swagger",
        text: "I'm back to shed some light.",
        voice: "swagger",
        form: 0,
      },
    ],
    ult_ally: [
      {
        id: "ult_ally_swagger",
        text: "Co-op time!",
        voice: "swagger",
        form: 0,
      },
    ],
    ult_enemy: [
      {
        id: "ult_enemy_cloak",
        text: "Us against the world!",
        voice: "cloak",
        form: 1,
      },
    ],
    secondary: [
      {
        id: "secondary_1_swagger",
        text: "Get in here, y'all.",
        voice: "swagger",
        form: 0,
      },
      {
        id: "secondary_2_cloak",
        text: "Welcome to the darkforce dimension!",
        voice: "cloak",
        form: 1,
      },
      {
        id: "secondary_3_cloak",
        text: "Let's pop back up under their noses.",
        voice: "cloak",
        form: 1,
      },
    ],
    ability2: [
      {
        id: "ability2_1_swagger",
        text: "A boom of life!",
        voice: "swagger",
        form: 0,
      },
      {
        id: "ability2_2_swagger",
        text: "Hold still! I'm trying to help!",
        voice: "swagger",
        form: 0,
      },
      {
        id: "ability2_3_swagger",
        text: "Just embrace the light!",
        voice: "swagger",
        form: 0,
      },
      {
        id: "ability2_4_cloak",
        text: "Suffer in the darkness!",
        voice: "cloak",
        form: 1,
      },
      {
        id: "ability2_5_cloak",
        text: "Taste MY pain.",
        voice: "cloak",
        form: 1,
      },
      {
        id: "ability2_6_cloak",
        text: "Live in fear!",
        voice: "cloak",
        form: 1,
      },
    ],
    ability1: [
      { id: "ability1_1_cloak", text: "Lights out.", voice: "cloak", form: 1 },
      {
        id: "ability1_2_swagger",
        text: "My time to shine.",
        voice: "swagger",
        form: 0,
      },
    ],
    kill: [
      {
        id: "kill_1_swagger",
        text: "Light consumes you.",
        voice: "swagger",
        form: 0,
      },
      { id: "kill_2_swagger", text: "Don't blink.", voice: "swagger", form: 0 },
      {
        id: "kill_3_swagger",
        text: "You can't hide from the light!",
        voice: "swagger",
        form: 0,
      },
      {
        id: "kill_4_swagger",
        text: "Just too bright for you.",
        voice: "swagger",
        form: 0,
      },
      {
        id: "kill_5_swagger",
        text: "Aww, it's nap time.",
        voice: "swagger",
        form: 0,
      },
      {
        id: "kill_6_swagger",
        text: "Score one for Tandy!",
        voice: "swagger",
        form: 0,
      },
      {
        id: "kill_7_cloak",
        text: "Drown in the abyss!",
        voice: "cloak",
        form: 1,
      },
      {
        id: "kill_8_cloak",
        text: "Darkness swallows you.",
        voice: "cloak",
        form: 1,
      },
      {
        id: "kill_9_cloak",
        text: "The Darkforce feeds…",
        voice: "cloak",
        form: 1,
      },
      { id: "kill_10_cloak", text: "All wrapped up.", voice: "cloak", form: 1 },
      {
        id: "kill_11_cloak",
        text: "Another one gone dark.",
        voice: "cloak",
        form: 1,
      },
      {
        id: "kill_12_cloak",
        text: "Score one for Ty!",
        voice: "cloak",
        form: 1,
      },
    ],
    multikill: [
      {
        id: "multikill_1_swagger",
        text: "Three! Feels good.",
        voice: "swagger",
        form: 0,
      },
      {
        id: "multikill_2_swagger",
        text: "Three in a row!",
        voice: "swagger",
        form: 0,
      },
      {
        id: "multikill_3_swagger",
        text: "That's three!",
        voice: "swagger",
        form: 0,
      },
      {
        id: "multikill_4_swagger",
        text: "Five's such a shiny number!",
        voice: "swagger",
        form: 0,
      },
      {
        id: "multikill_5_swagger",
        text: "Five alive, yeah!",
        voice: "swagger",
        form: 0,
      },
      {
        id: "multikill_6_swagger",
        text: "A fistful of triumph!",
        voice: "swagger",
        form: 0,
      },
      {
        id: "multikill_7_swagger",
        text: "What, were you all too bedazzled to help?",
        voice: "swagger",
        form: 0,
      },
      {
        id: "multikill_8_swagger",
        text: "I mean, you didn't have to let me do it all.",
        voice: "swagger",
        form: 0,
      },
      {
        id: "multikill_9_swagger",
        text: "I just shine a little brighter, don't I?",
        voice: "swagger",
        form: 0,
      },
      {
        id: "multikill_10_cloak",
        text: "I'll take three, until four comes along.",
        voice: "cloak",
        form: 1,
      },
      {
        id: "multikill_11_cloak",
        text: "Triple time.",
        voice: "cloak",
        form: 1,
      },
      {
        id: "multikill_12_cloak",
        text: "Whoo, three!",
        voice: "cloak",
        form: 1,
      },
      {
        id: "multikill_13_cloak",
        text: "Five? Must be somebody else's turn.",
        voice: "cloak",
        form: 1,
      },
      {
        id: "multikill_14_cloak",
        text: "Taking five.",
        voice: "cloak",
        form: 1,
      },
      {
        id: "multikill_15_cloak",
        text: "That's a handful.",
        voice: "cloak",
        form: 1,
      },
      {
        id: "multikill_16_cloak",
        text: "That's the Darkforce. Strong, and greedy too.",
        voice: "cloak",
        form: 1,
      },
      {
        id: "multikill_17_cloak",
        text: "I didn't mean to do it all myself.",
        voice: "cloak",
        form: 1,
      },
      {
        id: "multikill_18_cloak",
        text: "Ran the table. Sweet.",
        voice: "cloak",
        form: 1,
      },
    ],
    low_hp: [
      {
        id: "low_hp_1_swagger",
        text: "Hope I can return the favor sometime!",
        voice: "swagger",
        form: 0,
      },
      {
        id: "low_hp_2_swagger",
        text: "That was just in time.",
        voice: "swagger",
        form: 0,
      },
      {
        id: "low_hp_3_cloak",
        text: "That was the light I needed.",
        voice: "cloak",
        form: 1,
      },
      {
        id: "low_hp_4_cloak",
        text: "Thanks. Almost went dark there.",
        voice: "cloak",
        form: 1,
      },
    ],
    healed: [
      {
        id: "healed_1_swagger",
        text: "Ahh, thanks.",
        voice: "swagger",
        form: 0,
      },
      {
        id: "healed_2_swagger",
        text: "I'll get you next time.",
        voice: "swagger",
        form: 0,
      },
      {
        id: "healed_3_swagger",
        text: "Feeling good.",
        voice: "swagger",
        form: 0,
      },
      {
        id: "healed_4_cloak",
        text: "That took the edge off, thanks.",
        voice: "cloak",
        form: 1,
      },
      {
        id: "healed_5_cloak",
        text: "Appreciate the boost.",
        voice: "cloak",
        form: 1,
      },
      { id: "healed_6_cloak", text: "Right on!", voice: "cloak", form: 1 },
    ],
  },
} satisfies VoiceScript;

export default script;
